import React from "react";
import ScrollReveal from "@/components/ScrollReveal/ScrollReveal";
import { CONTACTS } from "@/constants/contacts";

export default function AboutPage() {
  return (
    <>
      <section className="page-intro" data-testid="page-intro">
        <div className="container">
          <ScrollReveal>
            <span className="eyebrow">SOBRE</span>
            <h1 className="h-1">Por que construímos o Akali AI</h1>
            <p className="body-lg page-intro-sub">
              Nasceu de uma clínica real, para resolver um problema real.
            </p>
          </ScrollReveal>
        </div>
      </section>

      <section className="section section-surface" data-testid="section-story">
        <div className="container">
          <ScrollReveal>
            <div className="prose">
              <p>
                O Akali AI nasceu da <strong>Akali Fisioterapia &amp; Pilates</strong>, em
                Barra Mansa (RJ). Como gestor de uma clínica de fisioterapia e
                Pilates, Marcus Marinho viveu de perto a realidade da
                documentação clínica no Brasil — tempo perdido, risco
                regulatório, e profissionais sobrecarregados.
              </p>
              <p>
                A parceria com <strong>Dra. Juliana Miranda</strong> trouxe a
                dimensão clínica que nenhuma tecnologia sozinha resolve:
                entender o que o fisioterapeuta realmente precisa documentar,
                como ele pensa durante uma sessão, e quais são os limites que
                uma IA deve respeitar nesse contexto.
              </p>
              <p>
                O resultado é um produto que acredita em <strong>inteligência
                aumentada</strong>, não substituição. O Akali AI é copiloto —
                você é o piloto.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="section section-deep" data-testid="section-team">
        <div className="container">
          <ScrollReveal>
            <div className="section-head">
              <span className="eyebrow">FUNDADORES</span>
              <h2 className="h-2">Quem está atrás do produto</h2>
            </div>
          </ScrollReveal>

          <div className="team-grid">
            <ScrollReveal delay={0.1} className="glass team-card glass-hover" data-testid="team-card-marcus">
              <span className="team-role">ESTRATÉGIA &amp; PRODUTO</span>
              <h3 className="team-name">Marcus Marinho</h3>
              <p className="team-bio">
                Fundador. Relações Internacionais (UNESA-RJ), Gestão de
                Negócios (FGV-RJ), IA Generativa (MIT). Experiência em
                inteligência competitiva e inovação na Firjan/IEL.
              </p>
              <p className="team-focus">Estratégia · Produto · Tecnologia · Parcerias</p>
            </ScrollReveal>

            <ScrollReveal delay={0.2} className="glass team-card glass-hover" data-testid="team-card-juliana">
              <span className="team-role">CLÍNICO &amp; PEDAGÓGICO</span>
              <h3 className="team-name">Dra. Juliana Miranda</h3>
              <p className="team-bio">
                Co-fundadora clínica. Fisioterapeuta e especialista em Pilates
                clínico. Responsável pela conformidade COFFITO e pela
                validação clínica dos outputs do sistema.
              </p>
              <p className="team-focus">Protocolos clínicos · Validação de qualidade · Formação de instrutores</p>
            </ScrollReveal>
          </div>

          <ScrollReveal delay={0.3}>
            <div className="glass mission" data-testid="mission">
              Nossa missão é devolver tempo ao fisioterapeuta brasileiro —
              para que cada minuto recuperado da documentação vire mais um
              paciente atendido, mais um resultado clínico entregue.
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.4}>
            <p
              className="mono-sm"
              style={{
                marginTop: 32,
                textAlign: "center",
                color: "var(--color-text-muted)",
              }}
              data-testid="about-contact-line"
            >
              Para falar com a equipe:{" "}
              <a
                href={`mailto:${CONTACTS.general}`}
                className="legal-mail"
                data-testid="about-contact-email"
              >
                {CONTACTS.general}
              </a>
            </p>
          </ScrollReveal>
        </div>
      </section>
    </>
  );
}
